import { Outlet } from "react-router-dom";

// Thin pass-through shell. The guard sits once at /waya-official; anything
// nested under this path — including a future moved-in ledger module —
// automatically inherits the role gate + OTP gate without needing its own.
const WayaOfficialOutlet = () => <Outlet />;

export default WayaOfficialOutlet;